import { render, staticRenderFns } from "./RecentOpenBidding.vue?vue&type=template&id=152fca32&scoped=true"
import script from "./RecentOpenBidding.vue?vue&type=script&lang=js"
export * from "./RecentOpenBidding.vue?vue&type=script&lang=js"
import style0 from "./RecentOpenBidding.vue?vue&type=style&index=0&id=152fca32&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "152fca32",
  null
  
)

export default component.exports